import React from "react";
import * as FaIcons from "react-icons/fa";
import * as MdIcons from "react-icons/md";
import * as BsIcons from "react-icons/bs";
import * as HiIcons from "react-icons/hi";
import * as RiIcons from "react-icons/ri";
import * as TbIcons from "react-icons/tb";
import * as FiIcons from "react-icons/fi";
import * as Io5Icons from "react-icons/io5";
import * as GiIcons from "react-icons/gi";
import * as LucideIcons from "lucide-react";

export const getIconComponent = (iconName) => {
  if (!iconName || typeof iconName !== "string") return LucideIcons.Settings;

  const trimmed = iconName.trim();

  // 1. Direct Lucide match
  if (LucideIcons[trimmed]) return LucideIcons[trimmed];

  // 2. Prefix matching for react-icons
  if (trimmed.startsWith("Fa") && FaIcons[trimmed]) return FaIcons[trimmed];
  if (trimmed.startsWith("Md") && MdIcons[trimmed]) return MdIcons[trimmed];
  if (trimmed.startsWith("Bs") && BsIcons[trimmed]) return BsIcons[trimmed];
  if (trimmed.startsWith("Hi") && HiIcons[trimmed]) return HiIcons[trimmed];
  if (trimmed.startsWith("Ri") && RiIcons[trimmed]) return RiIcons[trimmed];
  if (trimmed.startsWith("Tb") && TbIcons[trimmed]) return TbIcons[trimmed];
  if (trimmed.startsWith("Fi") && FiIcons[trimmed]) return FiIcons[trimmed];
  if (trimmed.startsWith("Io") && Io5Icons[trimmed]) return Io5Icons[trimmed];
  if (trimmed.startsWith("Gi") && GiIcons[trimmed]) return GiIcons[trimmed];

  // 3. Fallback searches across sets if prefix wasn't explicit
  if (FaIcons[trimmed]) return FaIcons[trimmed];
  if (MdIcons[trimmed]) return MdIcons[trimmed];
  if (BsIcons[trimmed]) return BsIcons[trimmed];
  if (HiIcons[trimmed]) return HiIcons[trimmed];
  if (RiIcons[trimmed]) return RiIcons[trimmed];
  if (TbIcons[trimmed]) return TbIcons[trimmed];
  if (FiIcons[trimmed]) return FiIcons[trimmed];
  if (Io5Icons[trimmed]) return Io5Icons[trimmed];
  if (GiIcons[trimmed]) return GiIcons[trimmed];

  return LucideIcons.Settings;
};

export const HeaderIcon = ({ icon, name, size = 18, className = "", style = {}, fallback = null }) => {
  const targetIconName = icon || name;
  const Component = getIconComponent(targetIconName);

  if (!Component) {
    if (fallback) return fallback;
    const FallbackComp = LucideIcons.Settings;
    return <FallbackComp size={size} className={className} style={style} />;
  }

  return <Component size={size} className={className} style={style} />;
};

export default HeaderIcon;
